import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section id="cta" className="relative overflow-hidden">
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-1/2 relative h-[350px] md:h-[500px]">
          <img
            src="https://readdy.ai/api/search-image?query=Fashion%20model%20from%20behind%20wearing%20oversized%20cream%20blazer%20and%20holding%20stylish%20tote%20bag%20against%20warm%20beige%20backdrop%2C%20soft%20golden%20hour%20light%2C%20editorial%20fashion%20photography%2C%20clean%20minimal%20composition%2C%20warm%20neutral%20tones%2C%20elegant%20lifestyle%20portrait%2C%20professional%20quality&width=900&height=700&seq=cta-visual-v2-01&orientation=portrait"
            alt="ACBuySpreadsheet fashion showcase"
            className="w-full h-full object-cover object-top"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
          <div className="absolute bottom-8 left-8">
            <h3 className="text-2xl md:text-4xl font-heading font-bold text-background-50 leading-tight">
              Ready to<br />Get Started?
            </h3>
          </div>
        </div>

        <div className="lg:w-1/2 flex items-center bg-background-50 py-16 md:py-20 px-8 md:px-16">
          <div className="max-w-lg mx-auto text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              Explore the Latest <span className="text-primary-500">ACBuy Spreadsheet</span>
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              Discover the easiest way to shop smarter with <strong>acbuy spreadsheet</strong>. Thousands of verified product links, updated weekly, so you never miss the <strong>best acbuy spreadsheet</strong> deals in 2026. Whether you are new or experienced, ACBuySpreadsheet is your trusted directory.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 bg-foreground-900 text-background-50 text-sm font-semibold rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                Explore KASpreadsheet
                <i className="ri-arrow-right-line"></i>
              </a>
              <Link
                to="/acbuy-spreadsheet-guide"
                className="px-8 py-3.5 border-2 border-foreground-300 text-foreground-800 text-sm font-semibold rounded-full hover:bg-foreground-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read Buying Guide
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}